var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgConnectionGreenIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99584 8.57847L6.54036 9.79977C5.78852 10.4132 5.27434 11.2698 5.08652 12.2217C4.8987 13.1737 5.04903 14.1614 5.51156 15.0144L2.47802 17.5598L3.33507 18.5812L6.3635 16.0401C7.1225 16.6481 8.07108 16.9701 9.0434 16.9496C10.0157 16.9291 10.9499 16.5676 11.6827 15.9281L13.1381 14.7068L7.99584 8.57847Z",
    fill: "#1EB89C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3844 5.89126C15.6229 5.28615 14.6737 4.96651 13.7013 4.98774C12.7288 5.00897 11.7945 5.36972 11.0601 6.00749L9.52804 7.29306L14.6703 13.4214L16.2024 12.1358C16.9594 11.5253 17.4777 10.6681 17.6667 9.71406C17.8557 8.76007 17.7034 7.76999 17.2363 6.91694L20.1882 4.44006L19.3311 3.41867L16.3844 5.89126Z",
    fill: "#1EB89C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgConnectionGreenIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/connection-green-icon.17afa3f6.svg";
export { ForwardRef as ReactComponent };